import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import ColorInput from 'components/Tvendo/Common/ColorInput';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsGetAll } from 'services/WService';

function NewLayerModal(props) {
  const { setOpen, showNotify } = props;
  const layer = props.model;

  const [color, setColor] = useState('#ffffff');
  const [selectedCanal, setSelectedCanal] = useState();
  const [canals, setCanals] = useState([]);
  const [selectedDivition, setSelectedDivition] = useState();
  const [layerDivitions, setLayerDivitions] = useState([]);

  async function listCanals() {
    let res = await wsGetAll('base/canal');
    if (res.success) {
      setCanals(res.data);
    }
  }

  async function listLayerDivitions() {
    let res = await wsGetAll('base/layer-divition');
    if (res.success) {
      setLayerDivitions(res.data);
    }
  }

  useEffect(() => {
    listCanals();
    listLayerDivitions();
  }, []);

  useEffect(() => {
    if (!!props.model.color) {
      setColor(props.model.color);
    } else {
      setColor('#ffffff');
    }
  }, [props.model]);

  useEffect(() => {
    if (layer.open === false) {
      setSelectedCanal(undefined);
    }
  }, [layer.open]);

  return (
    <Modal
      title={layer.id === undefined ? 'Nueva capa' : `Actualizando capa ${layer.name}`}
      showNotify={showNotify}
      entity="base/layer"
      setOpen={setOpen}
      model={layer}
      reload={props.reload}
      fullWidth
      maxWidth={'xs'}
    >
      <TextField
        label="Nombre"
        defaultValue={layer.name || ''}
        name="name"
        required
        fullWidth
        margin="normal"
      />
      <TextField
        label="Descripción"
        defaultValue={layer.description || ''}
        name="description"
        fullWidth
        margin="normal"
      />

      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Agrupamiento</InputLabel>
        <Select
          value={selectedDivition || layer.divition?.id || ''}
          name="divition_id"
          onChange={(e) => setSelectedDivition(e.target.value)}
        >
          {layerDivitions.map((divition) => {
            return (
              <MenuItem value={divition.id} key={divition.id}>
                {divition.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Canal</InputLabel>
        <Select
          value={selectedCanal || layer.base_canal_id || ''}
          name="base_canal_id"
          onChange={(e) => setSelectedCanal(e.target.value)}
        >
          <MenuItem value="">No</MenuItem>
          {canals.map((canal) => {
            return (
              <MenuItem value={canal.id} key={canal.id}>
                {canal.description}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      <ColorInput
        label="Color"
        name="color"
        color={color}
        setColor={setColor}
        showLayerIcon
        required
      />
    </Modal>
  );
}

export default NewLayerModal;
